<template>
  <div class="jm-stats-row">
    <div v-for="card in cards" :key="card.key" class="jm-stat-card">
      <div class="jm-stat-left">
        <span class="jm-stat-label">{{ card.title }}</span>
        <span class="jm-stat-value">{{ formatValue(card.key) }}</span>
      </div>
      <div class="jm-stat-icon" :style="{ background: card.bg, color: card.color }">
        <i :class="card.icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    metrics: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      cards: [
        { key: 'total_enrolled', title: 'Total Inscritos', icon: 'bx bx-user-plus', bg: '#eff6ff', color: '#3b82f6' },
        { key: 'active', title: 'Ativos Agora', icon: 'bx bx-play-circle', bg: '#ecfdf5', color: '#10b981' },
        { key: 'completed', title: 'Completaram', icon: 'bx bx-check-circle', bg: '#fffbeb', color: '#f59e0b' },
        { key: 'conversion_rate', title: 'Taxa de Conversao', icon: 'bx bx-trending-up', bg: '#f5f3ff', color: '#8b5cf6' }
      ]
    }
  },
  methods: {
    formatValue (key) {
      const val = this.metrics[key]
      if (val === undefined || val === null) return '-'
      if (key === 'conversion_rate') return val + '%'
      return val.toLocaleString ? val.toLocaleString('pt-BR') : val
    }
  }
}
</script>

<style scoped>
.jm-stats-row {
  display: flex;
  gap: 12px;
}
.jm-stat-card {
  flex: 1;
  background: #fff;
  border: 1px solid #e2e5eb;
  border-radius: 5px;
  padding: 16px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease;
}
.jm-stat-card:hover {
  border-color: #d1d5db;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
.jm-stat-left {
  display: flex;
  flex-direction: column;
}
.jm-stat-label {
  font-size: 13px;
  font-weight: 500;
  color: #5b6478;
  margin-bottom: 2px;
}
.jm-stat-value {
  font-size: 22px;
  font-weight: 800;
  color: #1a1d26;
  letter-spacing: -0.5px;
  line-height: 1.2;
}
.jm-stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .jm-stats-row {
    flex-wrap: wrap;
  }
  .jm-stat-card {
    flex: 1 1 calc(50% - 6px);
    min-width: 0;
  }
}
</style>
